import { Download, Loader2 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@quebon/ui/components/button'

interface Props {
  onClick: () => void
  disabled?: boolean
  isDownloading?: boolean
  error?: string | null
  className?: string
}

/** The owning print hook supplies capability gating and snapshot readiness. */
export function LmsPdfDownloadButton({ onClick, disabled, isDownloading = false, error, className }: Props) {
  const { t } = useTranslation('common')
  return (
    <div className="inline-flex flex-col items-start gap-1 print:hidden">
      <Button variant="outline" onClick={onClick} disabled={disabled || isDownloading} className={className}>
        {isDownloading ? <Loader2 data-icon="inline-start" className="animate-spin" /> : <Download data-icon="inline-start" />}
        {t(isDownloading ? 'printPdf.generating' : 'printPdf.download')}
      </Button>
      {error && <p role="alert" className="text-sm text-destructive">{error}</p>}
    </div>
  )
}
